



































import { Component, Vue, Prop } from 'vue-property-decorator';
import ProgressBar from '@/components/Commons/ProgressBar.vue';
import { vxm } from '@/store.vuex';

@Component({
    components:{
        ProgressBar
    }
})
export default class MissingMandatory extends Vue {
  @Prop () missedSteps;
  
  get profileStrength() {
    return vxm.users.myUserProfile.userProfileStrength;
  }

  relaunchGuidedSignup() {
    this.$emit('relaunch-guided-signup');
  }
}
